import React, { useEffect, useState } from "react";
import { MdKeyboardBackspace } from "react-icons/md";
import { RiDeleteBin6Fill } from "react-icons/ri";
import Swal from "sweetalert2";
import { useDispatch, useSelector } from "react-redux";
import {
  Run_QuickAction_Remove_Array_Success,
  Run_QuickAction_Remove_File_Success,
  Run_QuickAction_uploadFile_ActionHandler,
  Run_QuickAction_uploadFile_Success,
} from "../../../../Redux/Actions/user/RunQuickActionUploadFile";
import Loader from "../../../../Components/Loader/Loader";
import BatchRunOutput from "../BatchRunOutput/BatchRunOutput";
import { quick_Action_Run_Status_Success } from "../../../../Redux/Actions/user/RunQuickActionStatus";
import { ResizableBox } from "react-resizable";
import { Col, Row, Modal, Input, Form, Button, Drawer, Alert } from "antd";
import { Link } from "react-router-dom";
import TextArea from "antd/es/input/TextArea";
import { Run_QuickAction_uploadText_ActionHandler } from "../../../../Redux/Actions/user/RunQuickActionUploadText";
import { BASEURL } from "../../../../config";
import authAxios from "../../../../Config/AuthAxios";
import { fi } from "date-fns/locale";
const uploadIcon = "/assets/upload-c.svg";
const editIcon = "/assets/Edit-2.svg";
const UploadComputerData = ({
  quickrunData,
  back,
  isUploadOutComputer,
  setUploadComputerData,
  setText,
  datauploadComputer,
  params,
  quickrunStatusData,
  setAccessLevel,
  QuickSaveExecuteResponse,
  DragDropfile,
  setDragDropfile,
  setUploadEditData,
  setBack,
  showOutput,
  setShowOutput,
  setuplpad,
  setBatchProcessing,
  setFileLoader,
  fileLoader,
  uploadFilebyidAgain,
  setCoutingFiles,
  coutingFiles,
}) => {
  const dispatch = useDispatch();
  const SideClose = "/assets/ModalClose.svg";
  const [form] = Form.useForm();
  const fileInputRef = React.createRef();
  const [content, setContent] = useState([]);
  const [uploadInitiated, setUploadInitiated] = useState(false);
  const [open, setOpen] = useState(false);
  const [dataShow, setDataShow] = useState(false);

  let [totalSizeMP4MBArray, settotalSizeMP4MBArray] = useState([]);
  const uploadDocData = useSelector(
    (state) => state?.Run_quickAction_UploadFile_Data?.run_uploadFile_data
  );
  const uploadDocDataLoader = useSelector(
    (state) => state?.Run_quickAction_UploadFile_Data?.loader
  );
  const uploadTextData = useSelector(
    (state) => state?.Run_quickAction_UploadText_Data?.run_uploadText_data
  );

  useEffect(() => {
    dispatch(quick_Action_Run_Status_Success(null));
  }, []);
  useEffect(() => {
    return () => {
      dispatch(Run_QuickAction_Remove_Array_Success());
    };
  }, [dispatch]);
  useEffect(() => {
    if (isUploadOutComputer && !uploadInitiated && !DragDropfile) {
      fileInputRef.current.click();
      setUploadInitiated(true);
    }
  }, []);
  useEffect(() => {
    if (quickrunData?.status === "VALIDATING") {
      console.log("VALIDATING");
      setShowOutput(true);
    }
  }, [quickrunData]);
  useEffect(() => {
    if (uploadDocData && uploadDocData.length > 0)
      setUploadEditData(uploadDocData);
    setUploadComputerData(uploadDocData);
  }, [uploadDocData]);

  useEffect(() => {
    if (uploadTextData.id) {
      const payload = {
        id: uploadTextData.id,
        filename: uploadTextData.filename,
        content: uploadTextData.content,
        word_count: uploadTextData.word_count,
      };
      dispatch(Run_QuickAction_uploadFile_Success({ data: payload }));
    }
  }, [uploadTextData]);

  useEffect(() => {
    const files = DragDropfile;
    if (files.length > 0) {
      const allowedFileExtensions =
        /\.(pdf|mp3|mp4|txt|doc|docx|jpg|jpeg|png|tiff|bmp|heif)$/i;
      Array.from(files).forEach((file, index) => {
        if (allowedFileExtensions.test(file.name)) {
          UploadFileMutiple(
            `quick-action/${params}/run/upload-file`,
            { file },
            setFileLoader
          );
          // setFileLoader(true);
        } else {
          Swal.fire("Please select valid PDF, MP3, or MP4 files.");
          // setFileLoader(true);
        }
      });
    }
  }, [DragDropfile, dispatch]);

  const addOwnData = async (event) => {
    const payload = {
      title: event.title,
      data: event.description,
    };
    // dispatch(Run_QuickAction_uploadText_ActionHandler(payload, params));
    // dispatch(Run_QuickAction_uploadFile_Success({ data: payload }))

    const token = localStorage.getItem("token");
    try {
      setFileLoader(true);
      const res = await authAxios({
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
        method: "POST",
        url: BASEURL + `quick-action/${params}/run/create-file-from-text`,
        data: payload,
      });
      console.log(res);
      if (res?.status === 201) {
        const uploadedFileData = res?.data?.data;
        if (uploadedFileData) {
          if (uploadedFileData?.status === "PENDING") {
            let fileId = uploadedFileData.id;
            const fileData = await PollingUploadFileMutiple(fileId, params);
            setUploadComputerData((prevData) => [...prevData, fileData]);
          } else if (uploadedFileData.status === "COMPLETED") {
            setUploadComputerData((prevData) => [
              ...prevData,
              uploadedFileData,
            ]);
            setText((prevData) => [...prevData, uploadedFileData.content]);
          }
        }
      }

      setOpen(false);
      form.resetFields();
      setFileLoader(false);
    } catch (err) {
      const fileError = err?.response?.data?.data?.file[0];
      if (fileError !== undefined) {
        Swal.fire(fileError);
      } else {
        Swal.fire(err);
      }
      setFileLoader(false);
    } finally {
      // setFileLoader(false);
    }
  };

  const PollingUploadFileMutiple = async (
    fileId,
    quickactionId,
    delay = 3000
  ) => {
    const checkStatus = async () => {
      try {
        const token = localStorage.getItem("token");
        const res = await authAxios({
          headers: {
            Authorization: `Bearer ${token}`,
          },
          method: "GET",
          url:
            BASEURL + `quick-action/${quickactionId}/run/upload-file/${fileId}`,
        });

        if (res?.status === 200) {
          const responseData = res?.data;

          if (responseData?.data?.status === "COMPLETED") {
            setText((prevData) => [...prevData, responseData?.data?.content]);
            return responseData?.data;
          } else if (responseData?.data?.status === "FAILED") {
            Swal.fire({
              icon: "error",
              title: "Error",
              text: "File failed to process!",
            });
            return false;
          }
        }
      } catch (err) {
        throw err;
      }
    };

    let completed = false;
    let completedData = null;
    while (!completed) {
      const status = await checkStatus();

      if (status && status.status === "COMPLETED") {
        completedData = status;
        completed = true;
      } else if (status === false) {
        completed = true;
      } else {
        await new Promise((resolve) => setTimeout(resolve, delay));
      }
    }

    return completedData;
  };

  const UploadFileMutiple = async (apiUrl, datafile, setFileLoader) => {
    try {
      setFileLoader(true);
      const formData = new FormData();
      formData.append("file", datafile.file);

      const token = localStorage.getItem("token");
      const res = await authAxios({
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
        method: "POST",
        url: BASEURL + apiUrl,
        data: formData,
      });
      if (res?.status === 201) {
        const uploadedFileData = res?.data?.data;

        if (uploadedFileData) {
          if (uploadedFileData?.status === "PENDING") {
            let fileId = uploadedFileData.id;
            const fileData = await PollingUploadFileMutiple(fileId, params);
            setUploadComputerData((prevData) => [...prevData, fileData]);
            setText((prevData) => [...prevData, uploadedFileData.content]);
          } else if (uploadedFileData.status === "COMPLETED") {
            setUploadComputerData((prevData) => [
              ...prevData,
              uploadedFileData,
            ]);
            setText((prevData) => [...prevData, uploadedFileData.content]);
          }
        }
        setFileLoader(false);
      }
    } catch (err) {
      const fileError = err?.response?.data?.data?.file[0];
      if (fileError !== undefined) {
        Swal.fire(fileError);
      } else if (err?.response?.status === 500) {
        Swal.fire("Unable to extract data from the file. Please try again.");
      } else {
        Swal.fire(err);
      }
      setFileLoader(false);
    } finally {
      // setFileLoader(false);
    }
  };

  // useEffect(() => {
  //   console.log(datauploadComputer?.length, coutingFiles);
  //   if (datauploadComputer?.length === coutingFiles) {
  //     if (datauploadComputer?.every((item) => item?.status === "COMPLETED")) {
  //       setFileLoader(false);
  //     }
  //   }
  // }, [datauploadComputer]);

  // const handleFileChange = (event) => {
  //   const files = event.target.files;
  //   const allowedFileExtensions =
  //     /\.(pdf|mp3|mp4|txt|doc|docx|jpg|jpeg|png|tiff|bmp|heif)$/i;

  //   if (files) {
  //     setCoutingFiles((prev) => prev + files?.length);
  //     Array.from(files).forEach((file) => {
  //       if (allowedFileExtensions.test(file.name)) {
  //         // dispatch(Run_QuickAction_uploadFile_ActionHandler({ file }, params));
  //         UploadFileMutiple(
  //           `quick-action/${params}/run/upload-file`,
  //           { file },
  //           setFileLoader
  //         );
  //         // setFileLoader(true);
  //       } else {
  //         Swal.fire("Please select valid PDF, MP3, or MP4 files.");
  //         setFileLoader(false);
  //       }
  //     });
  //   }
  // };

  const handleFileChange = (event) => {
    console.log(totalSizeMP4MBArray);
    const files = event.target.files;
    const allowedFileExtensions =
      /\.(pdf|mp3|mp4|txt|doc|docx|jpg|jpeg|png|tiff|bmp|heif)$/i;
    if (files) {
      let mp4FilesCount = 0;
      Array.from(files).forEach((file) => {
        if (!allowedFileExtensions.test(file.name)) {
          Swal.fire("Please select valid PDF, MP3, or MP4 files.");
          setFileLoader(false);
          return;
        }
        if (file.type === "video/mp4") {
          mp4FilesCount++;
          const totalSizeMP4 = file.size / (1024 * 1024);
          totalSizeMP4MBArray.push(totalSizeMP4);
          settotalSizeMP4MBArray(totalSizeMP4MBArray);
        }
      });
      let sum = totalSizeMP4MBArray.reduce(
        (accumulator, currentValue) => accumulator + currentValue,
        0
      );
      if (sum > 300) {
        Swal.fire("The MP4 files size should not exceed 300MB.");
        setFileLoader(false);
        settotalSizeMP4MBArray([]);
        return;
      }
      setCoutingFiles((prev) => prev + files.length);
      Array.from(files).forEach((file) => {
        UploadFileMutiple(
          `quick-action/${params}/run/upload-file`,
          { file },
          setFileLoader
        );
      });
    }
  };

  const handleDeleteClick = (fileId, index) => {
    const updatedData = datauploadComputer?.filter(
      (item) => item?.id !== fileId
    );

    setText((prevData) => prevData.filter((_, i) => i !== index));
    if (updatedData) {
      setUploadComputerData(updatedData);
      setCoutingFiles((prev) => prev - 1);
    }
    // dispatch(Run_QuickAction_Remove_File_Success(fileId));
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  // const handlegetUploadDocData = (event, index) => {
  //   // const updatedContent = [...content];
  //   // updatedContent[index] = event.target.innerHTML;
  //   // setContent(updatedContent);
  //   setContent((prevContent) =>
  //     prevContent.map((item, idx) =>
  //       idx === index ? event.target.innerHTML : item
  //     )
  //   );
  // };
  const handlegetUploadDocData = (event, index) => {
    const newContent = event.currentTarget.innerHTML;
    setContent((prevContent) => {
      const updatedContent = [...prevContent];
      updatedContent[index] = newContent;
      return updatedContent;
    });
    setText((prevContent) => {
      const updatedContent = [...prevContent];
      updatedContent[index] = newContent;
      return updatedContent;
    });
    // if (newContent && !newContent.endsWith("<br>")) {

    // }
  };

  const showDrawer = () => {
    form.resetFields();
    setOpen(true);
  };
  const onClose = () => {
    setOpen(false);
    form.resetFields();
  };

  return (
    <div className="uploadComputer-data">
      {fileLoader && <Loader />}
      <div
        className="new-workspace-back-master"
        onClick={() => {
          setDragDropfile("");
          setBack();
          setAccessLevel("");
          setBatchProcessing("");
        }}
      >
        <MdKeyboardBackspace />
        Back
      </div>
      <div className="word-count-data">
        <div className="upload-out-computer-img-height-320">
          <div className="upload-out-computer-main-div">
            {datauploadComputer &&
              datauploadComputer?.map((file, index) => (
                <div key={index} className="">
                  <Row className="d-block upload-out-computer-span">
                    <div className="upload-out-computer-middle-div-first-p">
                      <Col
                        span={12}
                        className="margin-auto"
                        title={file?.filename}
                      >
                        {/* {file?.filename} */}
                        {file?.filename.length > 25
                          ? `${file?.filename.substring(0, 25)}...`
                          : file?.filename}
                      </Col>
                      <Col span={8}>
                        <div className="upload-out-computer-middle-div-second-p">
                          Word Count:{" "}
                          {new Intl.NumberFormat().format(
                            file.word_count
                              ? file.word_count
                              : uploadFilebyidAgain?.word_count
                              ? uploadFilebyidAgain?.word_count
                              : 0
                          )}
                        </div>
                      </Col>
                      <Col span={4} className="margin-auto">
                        <RiDeleteBin6Fill
                          className="upload-out-computer-delete-svg delete-Icon"
                          onClick={() => {
                            handleDeleteClick(file?.id, index);
                          }}
                        />
                      </Col>
                    </div>
                  </Row>
                </div>
              ))}
            {datauploadComputer?.length === 0 && (
              <div className="upload-computer-middle-div-first-p upload-out-computer-span">
                please click add more to upload.
              </div>
            )}
          </div>
          <input
            type="file"
            ref={fileInputRef}
            className="file-none"
            multiple
            onChange={handleFileChange}
            accept=".pdf, .mp3, .mp4, .txt, .doc, .docx, application/pdf, audio/mp3, video/mp4, text/plain, application/msword, jpeg.jpg, image/jpeg, image/png, .png, .tiff, .tif, image/tiff, image/bmp, .bmp, image/heif, .heif"
          />
        </div>
        {!quickrunStatusData?.result && (
          <div className="m-auto">
            <button
              onClick={() => fileInputRef.current.click()}
              className="add_more"
            >
              <img src={uploadIcon} alt="" />
              Upload more
            </button>
            <button onClick={showDrawer} className="add_more ml-3">
              <img src={editIcon} alt="" />
              Enter Your Own Data
            </button>
          </div>
        )}
        {showOutput ? (
          <BatchRunOutput
            data={quickrunStatusData}
            QuickSaveExecuteResponse={QuickSaveExecuteResponse}
            back={back}
            setAccessLevel={setAccessLevel}
            params={params}
            setuplpad={setuplpad}
            setShowOutput={setShowOutput}
            setBatchProcessing={setBatchProcessing}
            quickrunStatusData={quickrunStatusData?.status}
          />
        ) : (
          <div className="message-section-height-data margin-computerUpload ">
            <ResizableBox
              height={320}
              style={{
                whiteSpace: "pre-line",
                overflow: "hidden",
                padding: "10px",
                position: "relative",
              }}
            >
              <div
                style={{
                  overflow: "auto",
                  height: "100%",
                  width: "100%",
                }}
              >
                {datauploadComputer &&
                  datauploadComputer?.map((item, index) => (
                    <div
                      className="demo"
                      key={index}
                      onInput={(event) => {
                        handlegetUploadDocData(event, index);
                      }}
                      contentEditable
                      dangerouslySetInnerHTML={{
                        __html: `${
                          item.content
                            ? item?.content
                            : uploadFilebyidAgain?.content
                        }`,
                      }}
                    ></div>
                  ))}
              </div>
            </ResizableBox>
          </div>
        )}{" "}
        <Drawer title="" onClose={onClose} open={open} width={"35%"}>
          <img
            className="supporting-document-modal-sideClose"
            src={SideClose}
            alt=""
            onClick={onClose}
          />
          <h1>Add More Data</h1>
          <label>Enter Your own data</label>
          <Form
            form={form}
            name="owndata"
            initialValues={{ remember: true }}
            onFinish={addOwnData}
            style={{
              margin: "auto",
              marginTop: "30px",
            }}
          >
            <label>Title</label>
            <Form.Item
              name="title"
              rules={[
                {
                  required: true,
                  message: "Please input Title",
                },
                {
                  type: "text",
                  message: "Please enter a Title",
                },
              ]}
            >
              <Input placeholder="Write Title" />
            </Form.Item>
            <label>Data</label>
            <Form.Item
              name="description"
              rules={[
                {
                  required: true,
                  message: "Please Description",
                },
                {
                  type: "text",
                  message: "Please enter a Description",
                },
              ]}
            >
              <TextArea placeholder="Write Something" rows={15} />
            </Form.Item>
            <Form.Item className="text-center">
              <Button
                style={{ marginTop: "20px", width: "unset" }}
                type="primary"
                htmlType="submit"
                block
                className="submit_login-btn"
              >
                Add Data
              </Button>
            </Form.Item>
          </Form>
        </Drawer>
      </div>
    </div>
  );
};

export default UploadComputerData;
